import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fd61ce9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2fd61ce9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd61ce9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd61ce9')) {
      api.createRecord('2fd61ce9', component.options)
    } else {
      api.reload('2fd61ce9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fd61ce9&scoped=true&", function () {
      api.rerender('2fd61ce9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/index.vue"
export default component.exports